var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('object-menu-item',_vm._g({attrs:{"MenuItems":_vm.localMenu,"ObjectType":_vm.ObjectType,"Constraints":_vm.Constraints,"ParentNode":_vm.ParentNode}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }